document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.hg-menu-button');
  const nav = document.querySelector('.hg-nav');
  if (menuButton && nav) menuButton.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!open));
    nav.classList.toggle('open', !open);
  });
  document.querySelectorAll('[data-waitlist-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const dialog = document.querySelector(`[data-waitlist-dialog="${button.dataset.waitlistOpen}"]`);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    });
  });
  document.querySelectorAll('.hg-dialog').forEach((dialog) => {
    const close = dialog.querySelector('.hg-dialog-close');
    if (close) close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    if (dialog.querySelector('.hg-form-success') && typeof dialog.showModal === 'function') dialog.showModal();
  });
});
